import { useEffect, useRef, useState } from "react"
import styled from "@emotion/styled"
import { motion, useAnimationControls } from "framer-motion"

import { useConsole } from "contexts/Console"

import getMediaQuery from "css/breakpoints"

import Image from "components/media/ImageCLD"
import Video from "components/media/VideoCLD"

import { useValue } from "./context"

const Figure = styled(motion.figure)`
  display: grid;
  grid-column: col 1 / col -1;
  grid-row: fig;
  align-self: center;

  pointer-events: none;

  overflow: hidden;

  & picture {
    display: flex;
  }

  & img {
    width: 100%;
    height: auto;
  }

  & .video {
    grid-row: 1;
    grid-column: 1;
  }

  ${getMediaQuery("m")} {
    grid-column: col 1 / span 5;
    grid-row: top-row / bottom-row;
  }
`

function ImageFigure({ image }) {
  return <Image {...image} sizes='(min-width: 48rem) 35vw, 85vw' />
}

function VideoFigure({ video, index }) {
  const ref = useRef()

  const { currentIndex } = useValue()

  const onIndexChange = i => {
    i === index ? ref.current.play() : ref.current.pause()
  }
  useEffect(() => currentIndex.onChange(onIndexChange))

  return <Video ref={ref} {...video} autoPlay sizes='(min-width: 48rem) 35vw, 85vw' />
}

export function DescFigureMobile({ image, video, index, toggle }) {
  const console = useConsole()

  const { currentIndex } = useValue()

  const anim = useAnimationControls()

  const variants = {
    open: {
      opacity: 1,
      height: "auto",
      transition: { type: "tween", duration: 0.4, opacity: { duration: 0.4 } },
    },
    close: {
      opacity: 0,
      height: "0",
      transition: { type: "tween", duration: 0.4 },
    },
  }

  const onIndexChange = bool => anim.start(bool ? "open" : "close")
  useEffect(() => toggle.onChange(onIndexChange))

  return (
    <Figure variants={variants} animate={anim} initial={toggle.get() ? "open" : "close"}>
      {video?.sources?.length ? <VideoFigure video={video} index={index} /> : <ImageFigure image={image} />}
    </Figure>
  )
}

export default function DescFigure({ image, video, index }) {
  const console = useConsole()

  const { currentIndex } = useValue()

  const anim = useAnimationControls()

  const variants = {
    open: {
      opacity: 1,
      clipPath: "inset(0px 0px 0px 0px)",
      transition: { type: "tween", duration: 0.6, opacity: { duration: 0.4 } },
    },
    close: {
      opacity: 0,
      clipPath: "inset(50px 50px 50px 50px)",
      transition: { type: "tween", duration: 0.5 },
    },
  }

  const onIndexChange = i => anim.start(i === index ? "open" : "close")
  useEffect(() => currentIndex.onChange(onIndexChange))

  return (
    <Figure variants={variants} animate={anim} initial={currentIndex.get() === index ? "open" : "close"}>
      {video?.sources?.length ? <VideoFigure video={video} index={index} /> : <ImageFigure image={image} />}
    </Figure>
  )
}
